/**
 * @file BuilderPageWrapper.tsx
 * @module app/pages/layout-builder/BuilderPageWrapper
 * @description Renders the BuilderPageWrapper page used to configure and preview UTrade Admin layout settings.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.3.0
 */

import { FC } from "react";
import { PageTitle } from "../../../_admin/layout/core";
import { BuilderPage } from "./BuilderPage";

const BuilderPageWrapper: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>Layout Builder</PageTitle>
      <BuilderPage />
    </>
  );
};

export default BuilderPageWrapper;
